export default "__VITE_ASSET__BAKw5FoN__"